import React from 'react';
import Relay from 'react-relay';

import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';

import { css } from 'glamor';

import { ZINDEX_MODAL } from 'depop/styles/zIndex';
import { FAMILY_STANDARD, FAMILY_STANDARD_BOLD } from 'depop/styles/typography';
import { WHITE, RED, BLACK } from 'depop/styles/colors';

import ShopLink from 'depop/apps/shops/links/ShopLink';

import Cross from 'depop/components/icons/Cross';

import { closeMobileNavigation } from 'depop/state/navigation';

import AboutLink from './links/AboutLink';
import LoginLink from './links/LoginLink';
import DeepDownloadLink from './links/DeepDownloadLink';
import JobsLink from './links/JobsLink';
import EventsLink from './links/EventsLink';
import PressLink from './links/PressLink';
import SpacesLink from './links/SpacesLink';
import SupportLink from './links/SupportLink';
import InstagramLink from './links/InstagramLink';
import TwitterLink from './links/TwitterLink';
import FacebookLink from './links/FacebookLink';
import Logout from './Logout';
import LocaleSwitcher from './LocaleSwitcher';

const KEYCODES = {
  ESCAPE: 27,
};

function PrimaryMenuItem({ children }: { children: React.Element }) {
  return React.cloneElement(
    children,
    css({
      color: BLACK,
      fontSize: 20,
      lineHeight: 1.6,
      fontFamily: FAMILY_STANDARD_BOLD,
      cursor: 'pointer',
      textDecoration: 'none',
      ':hover': {
        textDecoration: 'underline',
      },
    }),
  );
}

function SecondaryMenuItem({ children }: { children: React.Element }) {
  return React.cloneElement(
    children,
    css({
      color: BLACK,
      fontSize: 20,
      lineHeight: 1.6,
      fontFamily: FAMILY_STANDARD,
      cursor: 'pointer',
      textDecoration: 'none',
      ':hover': {
        textDecoration: 'underline',
      },
    }),
  );
}

function SocialMenuItem({ children }: { children: React.Element }) {
  return React.cloneElement(
    children,
    css({
      color: BLACK,
      fontSize: 16,
      lineHeight: 1.6,
      fontFamily: FAMILY_STANDARD,
      cursor: 'pointer',
      textDecoration: 'none',
      ':hover': {
        textDecoration: 'underline',
      },
    }),
  );
}

class MobileMenu extends React.Component {
  handleKeyDown = event => {
    if (event.keyCode === KEYCODES.ESCAPE) {
      this.props.closeMobileNavigation();
    }
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      document.addEventListener('keydown', this.handleKeyDown);
    }

    if (prevProps.isOpen && !this.props.isOpen) {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }

  render() {
    const { user, isOpen, closeMobileNavigation } = this.props;

    return (
      <div
        {...css({
          position: 'fixed',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          top: 0,
          left: -216,
          transform: isOpen ? `translateX(216px)` : null,
          boxShadow: isOpen ? `8px 0 48px rgba(0, 0, 0, 0.2)` : null,
          zIndex: ZINDEX_MODAL,
          width: 216,
          bottom: -100,
          background: WHITE,
          color: BLACK,
          padding: '24px 32px 124px',
          transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        })}>
        <a
          {...css({
            display: 'block',
            width: 24,
            height: 24,
            padding: 4,
            cursor: 'pointer',
            ':hover': {
              color: RED,
            },
          })}
          onClick={closeMobileNavigation}>
          <Cross />
        </a>
        <div {...css({ height: 56, flexShrink: 0, flexGrow: 0 })} />
        <nav
          {...css({ display: 'flex', flexDirection: 'column', flexGrow: 1 })}>
          <ul
            {...css({
              listStyleType: 'none',
              margin: 0,
              padding: 0,
            })}>
            <li>
              <PrimaryMenuItem>
                {user ? <Logout /> : <LoginLink />}
              </PrimaryMenuItem>
            </li>
            <li>
              <PrimaryMenuItem>
                {user
                  ? <ShopLink user={user}>
                      <FormattedMessage
                        id="app.profileLabel"
                        description="Profile Label"
                        defaultMessage="Profile"
                      />
                    </ShopLink>
                  : <DeepDownloadLink />}
              </PrimaryMenuItem>
            </li>
          </ul>
          <div {...css({ height: 32, flexShrink: 0, flexGrow: 0 })} />
          <ul {...css({ listStyleType: 'none', margin: 0, padding: 0 })}>
            <li>
              <SecondaryMenuItem><AboutLink /></SecondaryMenuItem>
            </li>
            <li>
              <SecondaryMenuItem><JobsLink /></SecondaryMenuItem>
            </li>
            <li>
              <SecondaryMenuItem><EventsLink /></SecondaryMenuItem>
            </li>
            <li>
              <SecondaryMenuItem><SpacesLink /></SecondaryMenuItem>
            </li>
            <li>
              <SecondaryMenuItem><SupportLink /></SecondaryMenuItem>
            </li>
          </ul>
          <div {...css({ flexGrow: 1 })} />
          <ul {...css({ listStyleType: 'none', margin: 0, padding: 0 })}>
            <li>
              <SocialMenuItem><InstagramLink /></SocialMenuItem>
            </li>
            <li>
              <SocialMenuItem><TwitterLink /></SocialMenuItem>
            </li>
            <li>
              <SocialMenuItem><FacebookLink /></SocialMenuItem>
            </li>
          </ul>
          <div {...css({ height: 32, flexShrink: 0, flexGrow: 0 })} />
          <LocaleSwitcher />
        </nav>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeMobileNavigation: () => dispatch(closeMobileNavigation()),
  };
};

const connector = connect(null, mapDispatchToProps);

export default Relay.createContainer(connector(MobileMenu), {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        ${ShopLink.getFragment('user')}
        id
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/MobileMenu.js